import type { AxiosInstance } from 'axios';

import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const operatorMap: Record<string, string> = {
  'STARTS WITH': 'is',
};

const operatorMapInverse: Record<string, string> = {
  is: 'STARTS WITH',
};

const valueMap: Record<string, string> = {
  T: 'Detected',
  O: 'Demonstrated',
  R: 'Resolved',
  I: 'Accepted',
  D: 'Rejected',
};

const valueMapInverse: Record<string, string> = invertMap(valueMap);

async function fetchStatusOptions(_axios: AxiosInstance): Promise<string[]> {
  return Object.values(valueMap);
}

/**
 * Reusable field definition for Risk status.
 * Translates between API codes and UI labels.
 */
export const RiskStatus: SimpleFilterDefinition = {
  apiField: 'status',
  uiField: 'Status',
  inputType: 'dropdown',
  getAvailableValues: fetchStatusOptions,
  operators: ['is', 'is not'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Status',
      operator: getOperatorFromQueryFilter(queryFilter, operatorMap),
      value: getValueFromQueryFilter(valueMap, queryFilter),
    };
  },

  matchesQueryFilter: (queryFilter: QueryFilter): boolean => {
    return (
      queryFilter.field === 'status' && queryFilter.operator === 'STARTS WITH'
    );
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'status',
      operator: getOperatorFromSimpleFilter(simpleFilter, operatorMapInverse),
      value: getValueFromSimpleFilter(valueMapInverse, simpleFilter),
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
